const getErrorIsNotOutlook = (): string => {
  return "Ошибка. Текущий плагин предназначен только для работы внутри почтового сервиса Outlook";
};

export default getErrorIsNotOutlook;
